import { MenuItem, IconButton, Menu } from "@material-ui/core";
import React, { useState } from "react";
// import { Fragment } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import { checkShowModal } from "../../../modules/actions/cancelConfirm.action";
import { BootstrapTooltip } from "../ActionColumn";
import { resetMe } from "../../../modules/actions/me.action";
import {
  objectHasKeysCheck,
  userIsProductPartner,
} from "../../../services/commonMethods";
// import {ReactNotifications} from "react-notifications-component";
// import { DESC } from "../../../constants";
// import RealTimeNotifications from "../RealTimeNotification";
// import { requestNotifications } from "../../../modules/actions/notifications.action";
// import { initializePayloadMethod } from "../../../services/apiRequestMethods";
// import ReactWebSocket from "../ReactWebSocket";
// import { ENV_CONFIG, NOTIFICATION_TYPES_KEY } from "../../../constants";
// import { requestRefillList } from "../../../modules/actions/refillList.action";
// import { requestVMList } from "../../../modules/actions/vmList.action";
// import NotificationContainer from "../NotificationContainer";
import List from "../../../assets/icons/List.svg";
import Profile from "../../../assets/icons/new-profile-icon.svg";
import Notification from "../../../assets/images/bell.png";
import Envelope from "../../../assets/icons/Envelope.svg";
import UserIcon from "../../../assets/icons/user.svg";
import Key from "../../../assets/icons/Key.svg";
import { collapseSidebar } from "../../../modules/actions/collapseSidebar.action";
import { logOut } from "../../../modules/actions/login.action";
import Logout from "../../../assets/icons/log-out.svg";

function CustomTopNavBar(props) {
  // const notificationIsAllowed =
  //   props.me.Role && !userIsProductPartner.call({ props });
  const dispatchActions = useDispatch();
  const [notifyObj, setNotifyObj] = useState({});
  const state = useSelector((state) => state.cancelConfirmReducer);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const me = useSelector((state) => state.meReducer.data);
  const [anchorElNotification, setAnchorElNotification] = React.useState(null);

  const handleClickProfile = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  

  return (
    <>
      <div
        className="dash-header"
        style={{
          margin: "0px 0px 0px 5px",
          width: "calc(100% - 8px)",
        }}
      >
        <div className="left-header">
          <ul>
            <IconButton classes={{ root: "list-icon" }}>
              <img
                onClick={() => dispatchActions(collapseSidebar())}
                src={List}
                alt="List Icon Image"
                className="list-image"
              />
            </IconButton>
          </ul>
        </div>

        <div className="right-header">
          <ul>
            
            <li>
              {" "}
            
              {objectHasKeysCheck(me) ? (
                <IconButton
                  aria-label="slide"
                  classes={{ root: "slide-btn2 btn-dropdown" }}
                  onClick={handleClickProfile}
                  style={{ textTransform: "capitalize" }}
                >
                  <img src={Profile} alt="slide-btn" />{" "}
                </IconButton>
              ) : (
                ""
              )}
              <Menu
                id="simple-menu-notification"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className="menu-item menu-item-profile"
              >
                <MenuItem>
                  <img src={Key} alt="slide-btn" />{" "}
                  <span className="ellipsis user-profile-card__company-name ">
                    {props.me.Company
                      ? props.me.Company.name.replace(" ", "").toLowerCase()
                      : ""}
                  </span>
                </MenuItem>
                <MenuItem>
                  <img src={Envelope} alt="slide-btn" />
                  <span style={{textTransform : "lowercase"}}>
                  {props.me.email}
                  </span>
                </MenuItem>
                <MenuItem>
                  <span>
                    <img src={UserIcon} alt="slide-btn" />{" "}
                    {props.me?.Role?.name}
                  </span>
                </MenuItem>
                <MenuItem
                 onClick={() => [props.history.push("/notifications"),handleClose()]}
                >
                  <span>
                    <img  src={Notification} alt="slide-btn" />{" "}
                    Notifications
                  </span>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    dispatchActions(resetMe());
                    dispatchActions(logOut());
                  }}
                >
                  <span>
                    <img src={Logout} alt="slide-btn" /> Logout
                  </span>
                </MenuItem>
              </Menu>
            </li>
          </ul>
        </div>
      </div>
      {/* {notificationIsAllowed && (
        <ReactWebSocket
          url={ENV_CONFIG.notificationWebSocketUrl}
          onMessage={onMessageReceived}
        />
      )}
      {notifyObj && objectHasKeysCheck(notifyObj) ? (
        <RealTimeNotifications
          data={notifyObj}
          onRemoval={() => setNotifyObj({})}
        />
      ) : (
        ""
      )} */}
    </>
  );
}

const mapStateToProps = (state) => ({
  // refillListPayload: state.refillListReducer.payload,
  // vmListPayload: state.vmListReducer.others,
  me: state.meReducer.data,
});

const mapDispatchToProps = (dispatch) => ({
  // requestRefillList: (urlEndPoint, payload) =>
  //   dispatch(requestRefillList(urlEndPoint, payload)),
  // requestVMList: (urlEndPoint, payload) =>
  //   dispatch(requestVMList(urlEndPoint, payload)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomTopNavBar)
);
